/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserGroupBatchResponse {
    getFixupPrototypeFunction() { return UserGroupBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<UserGroupBatchResponse>): UserGroupBatchResponse {
        let obj = Object.assign(new UserGroupBatchResponse(), model);
        UserGroupBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserGroupBatchResponse>): UserGroupBatchResponse {
        if (!model) return null;
        return UserGroupBatchResponse.newInstance(<UserGroupBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserGroupBatchResponse) {
        if (!obj) return;

        models.UserGroupBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserGroupBatchResponse): boolean {
        Object.setPrototypeOf(obj, UserGroupBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.UserGroupDetails.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.UserGroupDetails; };

}
